import { apiClient } from "../config/api.config";
import { CreateFeedbackPayload, Feedback } from "../types/feedback.definition";

export function createFeedback(data: CreateFeedbackPayload) {
  return apiClient.request<Feedback>({
    method: "post",
    url: `/feedback`,
    data,
  });
}

export function getManagerFeedbacks(managerId: number) {
  return apiClient.request<Feedback[]>({
    method: "get",
    url: `/feedback/manager/${managerId}`,
  });
}

